class CommunicationsQueryKeys {
    prefix = 'communications';
    getCommunication(id) {
        return [this.prefix, id];
    }
    getCommunications(params) {
        return [this.prefix, params].filter(Boolean);
    }
}
export default CommunicationsQueryKeys;
